<template>
    <div class="signup">
        <v-card-title>新規登録</v-card-title>
        <v-text-field placeholder="Username" v-model="username"></v-text-field>
        <v-text-field type="password" placeholder="Password" v-model="password"></v-text-field>
        <v-btn @click="signUp">登録</v-btn>
        <p>登録済みの場合
            <router-link to="/signin">ログイン</router-link>
        </p>
    </div>
</template>

<script>
    import firebase from 'firebase'
    export default {
        name: 'Signup',
        data () {
            return {
                username: '',
                password: ''
            }
        },
        methods: {
            signUp: function () {
                firebase.auth().createUserWithEmailAndPassword(this.username, this.password)
                    .then(user => {
                        alert('Create account: ', user.email)
                        this.$router.push('/')
                    })
                    .catch(error => {
                        alert(error.message)
                    })
            }
        }
    }
</script>
